import { render, staticRenderFns } from "./ConsultaPrecios.vue?vue&type=template&id=c9f54fc2&scoped=true&"
import script from "./ConsultaPrecios.vue?vue&type=script&lang=js&"
export * from "./ConsultaPrecios.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaPrecios.vue?vue&type=style&index=0&id=c9f54fc2&scoped=true&lang=css&"
import style1 from "./ConsultaPrecios.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f54fc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VChip,VIcon,VImg,VProgressCircular})
